import { now } from '../util/now';
import { useServices } from './Services';
import { SsrData } from './SsrData';

export const makeServerTimestamp = (ssrData: SsrData) =>
  ssrData.slot('SERVER_TIMESTAMP', () => now().getTime());

export const useServerTimestamp = () => useServices().serverTimestamp;
